import { languageList, useTranslation } from '@pancakeswap/localization'
import { Menu as UikitMenu, useModal } from '@pancakeswap/uikit'
import { NextLinkFromReactRouter } from '@pancakeswap/widgets-internal'
import { styled } from 'styled-components'

import USCitizenConfirmModal from 'components/Modal/USCitizenConfirmModal'
import { NetworkSwitcher } from 'components/NetworkSwitcher'
import { useCakePrice } from 'hooks/useCakePrice'
import useTheme from 'hooks/useTheme'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { IdType } from 'hooks/useUserIsUsCitizenAcknowledgement'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import { useMenuItems } from './hooks/useMenuItems'
import UserMenu from './UserMenu'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'

const LinkComponent = (linkProps) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

/* ---- MacSwap smiley face logo (pure CSS) ---- */
const SmileyWrap = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: linear-gradient(145deg, #25cba8, #17b28e);
  box-shadow: 0 6px 14px rgba(31, 180, 148, 0.34);
  flex-shrink: 0;
`

const SmileyFace = styled.div`
  /* mouth – half-circle */
  position: absolute;
  width: 18px;
  height: 8px;
  border: 3px solid #fff;
  border-top: 0;
  border-radius: 0 0 18px 18px;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);

  /* eyes */
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -11px;
    width: 5px;
    height: 7px;
    background: #fff;
    border-radius: 999px;
  }
  &::before {
    left: 1px;
  }
  &::after {
    right: 1px;
  }
`

const MacSmiley = () => (
  <SmileyWrap>
    <SmileyFace />
  </SmileyWrap>
)

const Menu = (props) => {
  const { chainId } = useActiveChainId()
  const { isDark, setTheme } = useTheme()
  const cakePrice = useCakePrice()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useRouter()
  const [onUSCitizenModalPresent] = useModal(
    <USCitizenConfirmModal title={t('MacSwap Perpetuals')} id={IdType.PERPETUALS} />,
    false,
    false,
    'usCitizenConfirmModal',
  )

  const menuItems = useMenuItems(onUSCitizenModalPresent)

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  const getFooterLinks = useMemo(() => {
    return []
  }, [])

  return (
    <>
      <UikitMenu
        linkComponent={LinkComponent}
        rightSide={
          <>
            <NetworkSwitcher />
            <UserMenu />
          </>
        }
        chainId={chainId}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        cakePriceUsd={cakePrice.eq(BIG_ZERO) ? undefined : cakePrice}
        links={menuItems}
        subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
        footerLinks={getFooterLinks}
        activeItem={activeMenuItem?.href}
        activeSubItem={activeSubMenuItem?.href}
        buyCakeLabel={t('Buy MACH')}
        buyCakeLink="/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82&chainId=56"
        {...props}
      />
    </>
  )
}

export default Menu
